/**
 * V125 — 홈 팝업 모달(catalog-service `/admin/v1/home-popups`).
 *
 * ★오프라인 팝업스토어(`/admin/v1/popups`, features/cms/popups)와는 **완전히 다른 도메인**이다.
 * 이름만 겹치므로 화면·라우트·메뉴 모두 "홈 팝업"으로 구분해 부른다.
 */

/** 노출 기기. 미지정 = all(BE `normalizeDevice`). */
export const POPUP_DEVICES = ['all', 'pc', 'mobile'] as const;
export type PopupDevice = (typeof POPUP_DEVICES)[number];

/**
 * 노출 국가몰 코드 — BE `MallCodes.SUPPORTED` 정본과 동일 순서(BCP-47).
 * 지원 코드 외 값은 서버가 제거하므로 FE 도 이 집합만 보낸다.
 */
export const HOME_POPUP_MALLS = ['ko-KR', 'en-US', 'ja-JP', 'zh-CN'] as const;
export type HomePopupMall = (typeof HOME_POPUP_MALLS)[number];

export const HOME_POPUP_MALL_LABEL: Record<HomePopupMall, string> = {
  'ko-KR': '한국몰',
  'en-US': '영문몰',
  'ja-JP': '일본몰',
  'zh-CN': '중문몰',
};

/** 운영자 뷰(`HomePopupAdminView`) — 비활성·기간 종료 건도 그대로 내려온다. */
export interface HomePopup {
  id: number;
  popupKey: string;
  title: string;
  contentHtml: string;
  linkUrl: string | null;
  /** 네 값 모두 선택 — 크기 미지정 시 SF 기본 크기, 좌표 미지정 시 중앙 정렬. */
  width: number | null;
  height: number | null;
  positionX: number | null;
  positionY: number | null;
  device: string;
  /** null 또는 빈 배열 = 전체 노출(BE `MallCodes.normalize` + `isVisibleInMall`). */
  visibleMallCodes: string[] | null;
  todayCloseEnabled: boolean;
  /** ISO-8601. 시작은 inclusive, 종료는 exclusive. null = 제약 없음. */
  displayStartAt: string | null;
  displayEndAt: string | null;
  isActive: boolean;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
}

/**
 * 작성/수정 요청(`HomePopupRequest`).
 *
 * ★`popupKey` 는 생성 시에만 쓰이고 수정에서는 서버가 무시한다. FE 의 "오늘 하루 안 보기"
 * localStorage 키라 값이 바뀌면 이미 닫은 사용자에게 팝업이 다시 뜨기 때문이다.
 * 그래서 수정 폼은 이 값을 읽기 전용으로만 보여준다.
 */
export interface HomePopupPayload {
  popupKey: string;
  title: string;
  contentHtml: string;
  linkUrl?: string | null;
  width?: number | null;
  height?: number | null;
  positionX?: number | null;
  positionY?: number | null;
  device: PopupDevice;
  visibleMallCodes: string[] | null;
  todayCloseEnabled: boolean;
  displayStartAt?: string | null;
  displayEndAt?: string | null;
  isActive: boolean;
  sortOrder: number;
}

export interface HomePopupPagination {
  page: number;
  size: number;
  totalItems: number;
  totalPages: number;
}

export interface HomePopupListResult {
  items: HomePopup[];
  pagination: HomePopupPagination;
}

export interface HomePopupListQuery {
  page: number;
  size: number;
}
